/*
 * A color is "dark" if there is more contrast between #000000 and a reference
 * color than #FFFFFF and the reference color. That threshold can be expressed as a relative luminance
 * using the contrast formula as (1 + 0.5) / (R + 0.05) === (R + 0.05) / (0 + 0.05),
 * which reduces to the following, where 'R' is the relative luminance of the reference color
 */
const target = (-0.1 + Math.sqrt(0.21)) / 2;
/**
 * Determines if a `color` is dark according to relative luminance. That is, from a contrast perspective,
 * whether it has more contrast against white than black. In grey, dark is #757575 and darker.
 *
 * @param color - The color to check
 * @returns True when the `color` is dark
 *
 * @public
 */
export function isDark(color) {
    return color.relativeLuminance <= target;
}
